import { useEffect } from 'react';

const SEO = ({ 
    title, 
    description, 
    canonical,
    type = 'website',
    image = 'https://images.unsplash.com/photo-1763304046934-5735f8298fe9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80'
}) => {
    const siteTitle = 'Hypnosis Mastery Series';
    const fullTitle = title || siteTitle;
    const baseUrl = 'https://hypnosismasteryseries.com';
    
    useEffect(() => {
        // Update document title
        document.title = fullTitle;
        
        // Update meta tags
        const updateMeta = (name, content, isProperty = false) => {
            const attr = isProperty ? 'property' : 'name';
            let meta = document.querySelector(`meta[${attr}="${name}"]`);
            if (!meta) {
                meta = document.createElement('meta');
                meta.setAttribute(attr, name);
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', content || '');
        };
        
        // Determine canonical URL - use provided or derive from current path
        const canonicalUrl = canonical || `${baseUrl}${window.location.pathname}`;
        
        // Standard meta
        updateMeta('description', description);
        
        // Open Graph
        updateMeta('og:title', fullTitle, true);
        updateMeta('og:description', description, true);
        updateMeta('og:type', type, true);
        updateMeta('og:url', canonicalUrl, true);
        updateMeta('og:image', image, true);
        
        // Twitter
        updateMeta('twitter:card', 'summary_large_image');
        updateMeta('twitter:title', fullTitle);
        updateMeta('twitter:description', description);
        updateMeta('twitter:url', canonicalUrl);
        updateMeta('twitter:image', image);
        
        // Canonical link - always set
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            document.head.appendChild(link);
        }
        link.setAttribute('href', canonicalUrl);
        
    }, [fullTitle, description, canonical, type, image]);
    
    return null;
};

export default SEO;
